module.exports = __webpack_public_path__ + "static/media/health-life-science-landscape.db6de604.jpg";